import { render, staticRenderFns } from "./r-quest-show.vue?vue&type=template&id=0645dfaa"
import script from "./r-quest-show.vue?vue&type=script&lang=js"
export * from "./r-quest-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0645dfaa')) {
      api.createRecord('0645dfaa', component.options)
    } else {
      api.reload('0645dfaa', component.options)
    }
    module.hot.accept("./r-quest-show.vue?vue&type=template&id=0645dfaa", function () {
      api.rerender('0645dfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/quest/r-quest-show.vue"
export default component.exports